import * as constants from './constants'

export const MSConstant = constants
// 3
// 22
